import { logger } from "../../utils/logger";
import { createDemoContext } from "../context/demo_context";
import {
  createPipelineStepFailure,
  createPipelineStepSuccess,
} from "./pipeline_step";

export const runDemoPipeline = async ({
  steps = [],
  context = {},
  onStepStart,
  onStepComplete,
  onStepFailure,
} = {}) => {
  const results = [];
  const sharedContext = createDemoContext(context);

  logger.log("Experience pipeline started", {
    value: {
      stepCount: steps.length,
      stepNames: steps.map((step) => step?.name || "unnamed_step"),
    },
  });

  for (let index = 0; index < steps.length; index += 1) {
    const step = steps[index];
    const startedAt = Date.now();
    const stepName = step?.name || "unnamed_step";

    try {
      sharedContext.startedAt = startedAt;

      await onStepStart?.({ index, total: steps.length, step, sharedContext });

      const rawResult = await step.run(sharedContext);
      const result = rawResult?.step
        ? rawResult
        : createPipelineStepSuccess({
            step: step?.id || stepName,
            label: step?.label || stepName,
            created: rawResult?.created || 0,
            message: rawResult?.message || rawResult?.summary || "",
            metadata: rawResult || {},
            startedAt,
          });

      if (result?.metadata?.ready === false) {
        throw new Error(
          result.metadata.message || `${step?.label || stepName} was not ready.`
        );
      }

      results.push(result);
      step.afterSuccess?.({ result, sharedContext });

      await onStepComplete?.({
        index,
        total: steps.length,
        step,
        result,
        sharedContext,
      });

      logger.log(`Experience pipeline step completed: ${stepName}`, {
        value: result,
      });
    } catch (error) {
      const failure = createPipelineStepFailure({
        step: step?.id || stepName,
        label: step?.label || stepName,
        error,
        startedAt,
      });

      results.push(failure);

      await onStepFailure?.({
        index,
        total: steps.length,
        step,
        failure,
        error,
        sharedContext,
      });

      logger.warn(`Experience pipeline step failed: ${stepName}`, {
        value: { failure, error },
      });

      throw error;
    }
  }

  delete sharedContext.startedAt;

  return { results, demoContext: sharedContext };
};
